import React from 'react';

/**
 * Hero band for authenticated app pages: eyebrow, title, optional subtitle/description,
 * primary actions (e.g. CTAs), and optional aside (e.g. dashboard credit panel).
 * Styling uses CSS variables from index.css (.app-page-hero-*).
 */
export default function AppPageHero({
  eyebrow,
  lead,
  title,
  subtitle,
  description,
  actions,
  aside,
  className = '',
  compact = false,
}) {
  const padding = compact
    ? 'px-5 py-6 sm:px-8 sm:py-7'
    : 'px-6 py-8 sm:px-10 sm:py-10';

  return (
    <header
      className={`app-page-hero relative mb-10 overflow-hidden rounded-3xl border border-[var(--app-border)] bg-[var(--app-surface-strong)] shadow-[var(--app-panel-shadow)] ${padding} ${className}`.trim()}
    >
      <div
        className="pointer-events-none absolute -right-16 -top-24 h-64 w-64 rounded-full opacity-70 blur-3xl"
        style={{ background: 'var(--app-accent-soft)' }}
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-20 -left-10 h-48 w-48 rounded-full opacity-50 blur-3xl"
        style={{ background: 'rgba(251, 191, 36, 0.12)' }}
        aria-hidden
      />

      <div
        className={`relative flex min-w-0 flex-col gap-8 ${aside || actions ? `lg:flex-row lg:justify-between ${aside ? 'lg:items-start' : 'lg:items-end'}` : ''}`.trim()}
      >
        <div className="min-w-0 max-w-2xl flex-1">
          {lead ? <div className="mb-3">{lead}</div> : null}
          {eyebrow ? <p className="app-page-hero-eyebrow">{eyebrow}</p> : null}
          <h1
            className={`app-page-hero-title${compact ? ' app-page-hero-title--compact' : ''}`.trim()}
          >
            {title}
          </h1>
          {subtitle ? <div className="app-page-hero-subtitle">{subtitle}</div> : null}
          {description ? (
            <p className="app-page-hero-description">{description}</p>
          ) : null}
        </div>

        {(actions || aside) && (
          <div className="flex w-full shrink-0 flex-col items-stretch gap-3 sm:flex-row sm:items-center lg:w-auto lg:flex-col lg:items-end">
            {actions ? (
              <div className="flex flex-wrap gap-3 lg:justify-end">{actions}</div>
            ) : null}
            {aside ? <div className="w-full min-w-0 lg:max-w-md">{aside}</div> : null}
          </div>
        )}
      </div>
    </header>
  );
}
